// extracted by mini-css-extract-plugin
export default {"container":"aM-z","title":"bM-z","link":"cM-z"};